<template>
  <v-layout v-if="_deviceLocations" style="height:100%;" id="map">
    <GmapMap
      :center="{ lat: userPosition.lat, lng: userPosition.lng }"
      ref="map"
      :style="mapCss"
      :options="{
   zoomControl: true,
   mapTypeControl: true,
   scaleControl: true,
   streetViewControl: false,
   rotateControl: false,
   fullscreenControl: true,
   disableDefaultUi: false,
 }"
      @tilt_changed="updateDevices()"
    >
      <GmapMarker
        id="device-marker"
        v-for="(device, i) in devices"
        :key="i"
        :position="device.position"
        :radius="100"
        :icon="{
          url: currentIcon,
          scaledSize: { width: 28, height: 28 },
        }"
        @click="device.infoOpen = !device.infoOpen"
        :visible="true"
        :options="{
          fillColor: $vuetify.theme.currentTheme.primary,
          fillOpacity: 1.0,
        }"
      >
        <gmap-info-window
          v-if="_client.client_name === 'shark' && !isScreen"
          @closeclick="device.infoOpen = false"
          :opened="device.infoOpen"
          :position="device.position"
          :options="{
            pixelOffset: {
              width: 0,
              height: -5,
            },
          }"
        >
          <div class="d-flex text-capitalize" id="device-loc-screen-id">
            <h3>Course Name:</h3>
            <h3 class="pl-3">{{ getGroupName(device.group_id) }}</h3>
          </div>
          <div class="d-flex" id="device-loc-group-id">
            <h3>Lat/Long:</h3>
            <h3 class="pl-3">
              {{
                `${device.position.lat.toFixed(
                  4
                )}, ${device.position.lng.toFixed(4)}`
              }}
            </h3>
          </div>
          <div class="d-flex" id="device-loc-link">
            <h3>
              <a
                style="text-decoration: underline; color: #165EFF;"
                @click="getGroupUrl(device.group_id)"
                id="link-to-screen"
                >Link To Course</a
              >
            </h3>
          </div>
        </gmap-info-window>
        <gmap-info-window
          v-else
          @closeclick="device.infoOpen = false"
          :opened="device.infoOpen"
          :position="device.position"
          :options="{
            pixelOffset: {
              width: 0,
              height: -5,
            },
          }"
        >
          <div class="d-flex" id="device-loc-screen-id">
            <h3>Screen ID:</h3>
            <h3 class="pl-3">{{ device.id }}</h3>
          </div>
          <div class="d-flex" id="device-loc-group-id">
            <h3>Group Name:</h3>
            <h3 class="pl-3">{{ getGroupName(device.group_id) }}</h3>
          </div>
          <div class="d-flex" id="device-loc-link">
            <h3>Link To Screen:</h3>
            <a
              class="pl-3"
              style="font-weight:bold;"
              @click="getUrl(device.id)"
              id="link-to-screen"
              >View Screen</a
            >
          </div>
        </gmap-info-window>
      </GmapMarker>
    </GmapMap>
  </v-layout>
</template>
<script>
import { mapGetters, mapMutations } from 'vuex';
// import mapStyles from '../../assets/mapstyles.json';

export default {
  props: ['_deviceLocations', 'centerLocation', 'isScreen'],
  data() {
    return {
      deviceAmount: 0,
      userPosition: {
        lat: 39.71706,
        lng: -104.966553,
      },
      devices: [],
      bounds: null,
      // mapStyle: ,
    };
  },
  computed: {
    ...mapGetters({
      _getUnitInfo: 'maps/getUnitInfo',
      _client: 'account/getCurrentClient',
    }),
    currentIcon() {
      if (this._client.client_name === 'avis') {
        return require('../../assets/Avis-Car.svg');
      }
      if (this._client.client_name === 'bazzbi') {
        return require('../../assets/golf-cart-CC.svg');
      }
      return require('../../assets/SharkFlag@3x.svg');
    },
    mapCss() {
      if (this.$route.name === 'Devices') {
        return 'width: 100%; height: 84vh;';
      }
      return 'width: 100%; height: 600px;';
    },
  },
  methods: {
    ...mapMutations({
      _setMapData: 'maps/setMapData',
    }),
    updateDevices() {
      this.devices = this._deviceLocations;
    },
    getUrl(id) {
      this.$router.push(
        `/${this._client.client_name
          .toLowerCase()
          .replace(/\s/g, '')}/screens/${id}`
      );
    },
    getGroupUrl(id) {
      this.$router.push(
        `/${this._client.client_name
          .toLowerCase()
          .replace(/\s/g, '')}/groups/${id}`
      );
    },
    getGroupName(id) {
      let screenGroup = null;
      this._client.groups.map(group => {
        if (group.uuid === id) {
          screenGroup = group;
        }
      });
      if (screenGroup) {
        return screenGroup.group_name;
      }
      return id;
    },
  },
  watch: {
    devices: {
      handler() {
        if (this.deviceAmount !== this.devices.length) {
          const bounds = new window.google.maps.LatLngBounds();
          this._deviceLocations.forEach((m) => {
            bounds.extend(m.position);
          });
          if (!this.bounds) {
            this.bounds = bounds;
          }
        }
        this.deviceAmount = this.devices.length;
      },
      deep: true,
    },
    bounds: {
      handler() {
        if (this.bounds) {
          this.$refs.map.$mapObject.fitBounds(this.bounds);
        }
        if (this.devices.length === 1) {
          this.$refs.map.$mapObject.setZoom(15);
        }
      },
      deep: true,
    },
    _deviceLocations: {
      handler() {
        this.updateDevices();
        if (this.devices.length > 0) {
          this.bounds = null;
        }
      },
      deep: true,
    },
    centerLocation: {
      handler() {
        this.userPosition = this.centerLocation;
      },
      deep: true,
    },
  },
};
</script>
